import { API_URL } from "../../enums/api.enums";
import Utils from "../../utils/base-utils";

export interface IPointRateResponse {
    rate: number;
}

export interface ISetPointRateRequest {
    rate: number;
}

export interface ISetPointRateResponse {
    message: string;
}

export const getPointRate = async (): Promise<IPointRateResponse> => {
    let token: any = localStorage.getItem("token");
    token = token?.replace(/['"]+/g, '');
    
    const response = await fetch(`${API_URL.HOST}/points/admin/point-rate`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};

export const setPointRate = async (request: ISetPointRateRequest): Promise<ISetPointRateResponse> => {
    let token: any = localStorage.getItem("token");
    token = token?.replace(/['"]+/g, '');
    
    const response = await fetch(`${API_URL.HOST}/points/admin/point-rate`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(request),
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};
